import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import FeedProperty from "../feed-property/component";

class Feed extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: []
        };
    };

    componentDidMount() {

        this.setState({
            items: this.props.items
        });

        try{
            const slider = document.querySelector('#carousel_slider');
            let isDown = false;
            let startX;
            let scrollLeft;
            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mousemove', (e) => {
                if(!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 1; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
            });
        }catch (e) {}

    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            items: nextProps.items
        })
    }

    render() {
        return (
            <div className={Styles.container}>
                <div className={Styles.containerInner} id={"carousel_slider"}>
                    {
                        this.state.items.sort((a, b) => {
                            return b.date - a.date
                        }).filter((item, index) => {
                            return index <= this.state.items.length
                        }).map((item) => {
                            return (
                                <div style={{marginRight: "calc(var(--size-factor) * 40px"}}>
                                    <FeedProperty
                                        data={item}
                                    />
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}

export default Feed;


// WEBPACK FOOTER //
// ./src/components/feed/component.js